import { render } from "./RealtimeUploadErrorCard.vue?vue&type=template&id=00bb1542&ts=true"
import script from "./RealtimeUploadErrorCard.vue?vue&type=script&lang=ts"
export * from "./RealtimeUploadErrorCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__